import { ENDPOINTS } from "../services/Endpoints";
import Compressor from "compressorjs";
import { i18n } from "../main";
import store from "../store";

export default {
  data() {
    return {
      modalSelectLoja: false,
      ENDPOINTS: ENDPOINTS,
      status: [
        { text: i18n.t("events.active"), value: "ATIVO" },
        { text: i18n.t("events.inactive"), value: "INATIVO" },
        { text: i18n.t("events.sold-out"), value: "ESGOTADO" },
      ],
      tipoValues: "",
      tipoKeys: "",
      optionsObject: "",
      optionsObjectOld: "",
      value5: "1234567.89",
      label5: "Money pt-BR",
      readonly5: false,
      disabled5: false,
      outlined5: true,
      clearable5: false,
      options5: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
      headersVariacoes: [
        {
          text: "Variação",
          align: "center",
          width: 200,
          sortable: true,
          value: "descricao",
        },
        {
          text: "Preço",
          align: "center",
          width: 250,
          sortable: true,
          value: "preco",
        },
        {
          text: "Quantidade",
          align: "center",
          width: 150,
          sortable: true,
          value: "quantidade",
        },
        {
          text: "Ativo",
          align: "center",
          width: 150,
          sortable: true,
          value: "status",
        },
      ],
      // header da tabela
      headersVariantes: [
        {
          text: "Nome",
          align: "start",
          sortable: true,
          value: "descricao",
        },
        {
          text: "Quantidade",
          align: "start",
          sortable: true,
          value: "quantidade",
        },
        {
          text: "Preço",
          align: "start",
          sortable: true,
          value: "preco",
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      headersImgs: [
        {
          title: "Imagem",
        },
        {
          title: "Url",
        },
        {
          title: "Ações",
        },
      ],

      // pickers de data e hora na tabela abaixo
      activePicker: null,
      activePicker2: null,
      activePicker3: null,
      activePicker4: null,
      date: null,
      hour: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dtInicial: "",
      dtFinal: "",
      placeholderData: "dd/mm/aaaa",
      placeholderHora: "hh:mm",
      horaInicial: "",
      horaFinal: "",
      imagemModal: "",
      tipo_imagem: [
        {
          key: "Imagem Home",
          value: "imagem1",
          show: true,
        },
        {
          key: "Imagem Produto",
          value: "destaque",
          show: true,
        },
      ],
      tipo_imagem_iframe: [
        {
          key: "Imagem 1",
          value: "imagem1",
          show: true,
        },
        {
          key: "Destaque",
          value: "destaque",
          show: true,
        },
      ],
      tipo_imagem_link: [
        {
          key: "Imagem 1",
          value: "imagem1",
          show: true,
        },
        {
          key: "Destaque",
          value: "destaque",
          show: true,
        },
      ],
      textModalConfirm: "",
      imageValueModalConfirm: "",
      indexModalConfirm: "",
    };
  },
  computed: {
    headersProdutos() {
      return [
        {
          text: i18n.t("events.event-description"),
          align: "start",
          sortable: true,
          value: "descricao",
        },
        {
          text: i18n.t("events.stock"),
          align: "end",
          sortable: true,
          value: "estoque",
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: i18n.t("events.revert-fee"),
          align: "start",
          value: "revertTax",
          sortable: false,
        },
        {
          text: i18n.t("events.revert-fee-date-hour"),
          align: "start",
          value: "dthr_reverter",
          sortable: false,
          width: 160,
        },
        {
          text: i18n.t("events.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
    },
    tags() {
      return [
        { key: i18n.t("events.event-config.sale"), value: "PROMOÇÃO" },
        { key: i18n.t("events.event-config.discount"), value: "DESCONTO" },
        { key: i18n.t("events.event-config.news"), value: "NOVIDADE" },
      ];
    },
    isRegister() {
      if (this.$route.params.type === "cadastrar") return true;
      return false;
    },
    getProductId() {
      if (this.isRegister) {
        if (this.imgIsEmpty) return null;
        else return this.$produtos_gerenciar.cadastro.idproduto;
      } else {
        return this.$produtos_gerenciar.cadastro.idproduto;
      }
    },
    imgIsEmpty() {
      if (
        this.$produtos_gerenciar.cadastro.customizacao.imagens_array.length == 0
      )
        return true;
      return false;
    },
    getStoreId() {
      let upload;

      if (this.$axios.getLocal("loja_produtos_selecionada")) {
        return (upload = this.$axios.getLocal(
          "loja_produtos_selecionada"
        ).data);
      }
      if (
        this.$axios.getLocal("oe_user_info") &&
        this.$axios.getLocal("oe_user_info")?.data
      ) {
        return (upload = this.$axios.getLocal("oe_user_info")?.data?.loja);
      }
      return upload.toString();
    },
  },
  methods: {
    /**
     * @description Método que abre o modal de seleção de lojas
     */
    openModalSelect() {
      this.$produtos_gerenciar.lojas_loading = true;
      this.$produtos_gerenciar.loja_selecionada = "";
      this.$produtos_gerenciar.modalSelectStore = true;
    },

    /**
     * @description Método que abre o modal
     * @param {String} name - Classe do modal para abrir
     */
    openModal(name) {
      document.getElementsByClassName(name)[0].style.display = "flex";
    },

    /**
     * @description Método para selecionar imagem no file input
     * @param {String} file - Objeto da imagem
     */
    getImagem(file) {
      // let img = new Image();
      // img.src = window.URL.createObjectURL(file);
      // img.onload = () => {
      //   if (img.width > 780 && img.height > 260) {
      //     this.$config.alert(
      //       "As dimensões são maiores que as permitidas",
      //       this.$config.dados.errorColor
      //     );
      //     this.$refs.fileInputRef.internalValue = null;
      //   }
      // };
      if (!file) return;
      const self = this;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.$produtos_gerenciar.cadastro.customizacao.imagem_upload.imagem =
          reader.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },

    /**
     * @description Método que faz upload da imagem para o s3
     * @param {String} file - Objeto da imagem
     */
    async uploadImage(file) {
      this.$produtos_gerenciar.cadastro.customizacao.error.imagem_upload = [];
      let newFile;
      await new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.8,
          convertSize: 100000,
          success: async result => {
            const base64 = await this.blobToBase64(result);
            newFile = base64;
            resolve();
          },
          error: error => {
            reject(error);
          },
        });
      });

      if (this.$produtos_gerenciar.cadastro.customizacao.imagem == "") {
        this.$config.alert(
          "Selecione o tipo de imagem!",
          this.$config.dados.errorColor
        );
        this.$produtos_gerenciar.cadastro.customizacao.error.imagem =
          "Selecione o tipo de imagem!";
        return;
      }

      if (
        this.$produtos_gerenciar.cadastro.customizacao.imagem_upload.object ===
        undefined
      ) {
        this.$config.alert(
          "Selecione uma imagem para realizar o upload!",
          this.$config.dados.errorColor
        );
        this.$produtos_gerenciar.cadastro.customizacao.error.imagem_upload =
          "Selecione uma imagem para realizar o upload!";
        return;
      }

      this.$produtos_gerenciar.cadastro.customizacao.loading_imagem = true;
      this.$axios
        .post(this.ENDPOINTS.UPLOAD_IMAGEM_PRODUTO, {
          img_base64: newFile,
          ...(!store.getters.isStoreKeeper && {
            loja: store.getters.storeSequencial,
          }),
          idproduto: this.getProductId,
          tipo_imagem: this.$produtos_gerenciar.cadastro.customizacao.imagem,
        })
        .then(response => {
          const object = {};

          if (this.isRegister && this.imgIsEmpty) {
            this.$produtos_gerenciar.cadastro.idproduto = response.idproduto;
          }
          object[this.$produtos_gerenciar.cadastro.customizacao.imagem] =
            response.url;
          this.$produtos_gerenciar.cadastro.customizacao.imagens_array.push(
            object
          );
          this.$produtos_gerenciar.cadastro.customizacao.loading_imagem = false;

          (this.$produtos_gerenciar.cadastro.customizacao.imagem = ""),
            (this.$produtos_gerenciar.cadastro.customizacao.imagem_upload.imagem =
              null);
          delete this.$produtos_gerenciar.cadastro.customizacao.imagem_upload
            .object;
        })
        .catch(error => {
          this.$produtos_gerenciar.cadastro.customizacao.loading_imagem = false;
          throw new Error(error);
        });
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64String = reader.result;
          resolve(base64String);
        };
        reader.onerror = error => {
          reject(error);
        };
      });
    },

    /**
     * @description Método para abir o modal para visualização da imagem
     * @param {String} imagem - URL da imagem
     */
    previewImage(imagem) {
      document.getElementsByClassName(
        "modal-body-visualizar-imagem"
      )[0].style.display = "flex";
      this.imagemModal = imagem;
    },

    /**
     * @description Método para remover imagem da tabela de imagens
     * @param {String} index - iIndice da imagem que será removida
     * @param {String} i - Nome da opção no select de tipos de imagem
     */
    removeImage(index, i) {
      let tipo;
      const cadastro = this.$produtos_gerenciar.cadastro;
      const customizacao = cadastro.customizacao;

      if (cadastro.dados_cadastrais.tipo === "IFRAME") {
        customizacao.imagens_array.splice(index, 1);
        tipo = this.tipo_imagem_iframe.find(item => item.value === i);
      } else if (cadastro.dados_cadastrais.tipo === "LINK") {
        customizacao.imagens_array.splice(index, 1);
        tipo = this.tipo_imagem_link.find(item => item.value === i);
      } else {
        customizacao.imagens_array.splice(index, 1);
        tipo = this.tipo_imagem.find(item => item.value === i);
      }

      if (tipo) {
        tipo.show = true;
      }
    },

    /**
     * @description Método para remover imagem do input
     */
    clearImage() {
      // (this.$produtos_gerenciar.cadastro.customizacao.imagem = ""),
      this.$produtos_gerenciar.cadastro.customizacao.imagem_upload.imagem =
        null;
    },

    /**
     * @description Método para abrir o modal de confirmação de remoção de produto
     * @param {index} String - index da imagem
     * @param {i} String - index da imagem
     * @param {msg} String - Mensagem de confirmação
     */
    remover(index, i, msg) {
      this.$config.modalConfirm = true;
      this.textModalConfirm = msg;
      this.imageValueModalConfirm = i;
      this.indexModalConfirm = index;
    },

    /**
     * @description Método de confirmação de remoção de produto
     */
    funcaoRemover() {
      this.removeImage(this.indexModalConfirm, this.imageValueModalConfirm);
      this.$produtos_gerenciar.cadastro.customizacao.imagem_upload.imagem =
        null;
    },
  },
};
